module.exports = __webpack_public_path__ + "img/mbp-16-ubuntu.609403c6.webp";